import { getCsrfToken } from "./genericApi.ts";
import { KontoAdmin, KontoFilter } from "@/services/adminApi.ts";
import {PagedResult} from "@/services/actorenApi.ts";

export type KontoStatus = 'PENDING' | 'ACTIEF' | 'GESCHORST' | 'GEWEIGERD';

export interface Konto {
    id: number,
    geldig: boolean,
    soort: string,
    competenties: string[],
    van: string,
    tot: string,
    houder: number,
    nisOperationeel: number
}

export interface KontoSettings {
    id: number,
    competenties: string[],
    nisOperationeel: string,
    procesCertificaatNummer: string,
    agendaServiceProvider: string,
    kalenderAccountId: string,
    kalenderId: string,
    appleAppSpecificPassword: string,
    iban : string,
    factuurAdres: string
    factuurNaam: string
}


export async function getKonto(id: any): Promise<Konto> {

    if (id == null) return null

    const response = await fetch('/api/konto/' + id, {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = await response.json()
    return data

}

export async function getKontoSettings(id: any): Promise<KontoSettings> {

    if (id == null) return null

    const response = await fetch('/api/konto/' + id + '/settings', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = await response.json()
    return data

}

export async function saveKontoSettings(id: number, kontoSettings: KontoSettings) {
    const token = getCsrfToken();

    const response = await fetch('/api/konto/' + id + '/settings', {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: JSON.stringify(kontoSettings),
        credentials: 'include', // if you need cookies/session
    })

    if (!response.ok) {
        const text = await response.text()
        console.error('❌ Error:', text)
        throw new Error(`Failed to save draft: ${response.statusText}`)
    }
    return true
}

export async function getRichtprijzen(id: number): Promise<any> {
    if (id == null) return null
    const response = await fetch('/api/konto/' + id + '/richtprijzen', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = await response.json()
    return data;
}


export async function saveRichtprijzen(id: number, rp: any)     {
    const token = getCsrfToken();

    const response = await fetch('/api/konto/' + id + '/richtprijzen', {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: JSON.stringify(rp),
        credentials: 'include', // if you need cookies/session
    })

    if (!response.ok) {
        const text = await response.text()
        console.error('❌ Error:', text)
        throw new Error(`Failed to save draft: ${response.statusText}`)
    }
    return true;
}

export async function getRichttijden(id: number): Promise<any> {
    if (id == null) return null
    const response = await fetch('/api/konto/' + id + '/richttijden', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = await response.json()
    return data;
}


export async function saveRichttijden(id: number, rp: any)     {
    const token = getCsrfToken();

    const response = await fetch('/api/konto/' + id + '/richttijden', {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: JSON.stringify(rp),
        credentials: 'include', // if you need cookies/session
    })

    if (!response.ok) {
        const text = await response.text()
        console.error('❌ Error:', text)
        throw new Error(`Failed to save draft: ${response.statusText}`)
    }
    return true;
}





export async function getQRCodes(id: number): Promise<string[]> {
    if (id == null) return null
    const response = await fetch('/api/konto/' + id + '/qrcodes', {
        method: 'GET',
        credentials: 'include',
    })
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
    }
    const data = response.json()
    return data;
}

export async function createQRCode(id: number, origin: string) {
    const token = getCsrfToken();

    const response = await fetch('/api/konto/' + id + '/qrcode/' + origin, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: '',
        credentials: 'include', // if you need cookies/session
    })

    if (!response.ok) {
        const text = await response.text()
        console.error('❌ Error:', text)
        throw new Error(`Failed to save draft: ${response.statusText}`)
    }
    return response;
}

export async function deleteQRCode(id: number, origin: string) {
    const token = getCsrfToken();

    const response = await fetch('/api/konto/' + id + '/qrcode/' + origin, {

        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': token || '',
        },
        body: '',
        credentials: 'include', // if you need cookies/session
    })

    if (!response.ok) {
        const text = await response.text()
        console.error('❌ Error:', text)
        throw new Error(`Failed to save draft: ${response.statusText}`)
    }
    return response;
}
export async function uploadKontoFoto(kontoId: number, afdeling: string, file: File): Promise<void> {
    const token = getCsrfToken();
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('kontoId', kontoId.toString());
    formData.append('afdeling', afdeling);
    formData.append('mimeType', file.type);
    formData.append('functie', 'LOGO');

    const response = await fetch('/api/konto/foto/upload', {
        method: 'POST',
        headers: {
            'X-XSRF-TOKEN': token || '',
        },
        body: formData,
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error(`Failed to upload photo: ${response.statusText}`);
    }
}

export async function checkKontoFotoExists(kontoId: number): Promise<boolean> {
    try {
        const response = await fetch(`/api/konto/${kontoId}/foto`, {
            method: 'HEAD',
            credentials: 'include',
        });
        return response.ok;
    } catch (error) {
        console.error('Error checking foto existence:', error);
        return false;
    }
}

export async function zoekKonto(
    filter: KontoFilter,
    page = 0,
    size = 20
): Promise<PagedResult<KontoAdmin>> {
    const params = new URLSearchParams({
        page: String(page),
        size: String(size),
        ...cleanFilter(filter)
    });
    const response = await fetch(`/api/admin/kontos?${params}`, {
        method: 'GET',
        credentials: 'include'
    });
    if (!response.ok) throw new Error(`zoekKonto failed: ${response.status}`);
    return response.json();
}

// drop undefined/empty values so URLSearchParams doesn't emit "status=undefined"
function cleanFilter(filter: Record<string, any>): Record<string, string> {
    return Object.fromEntries(
        Object.entries(filter).filter(([, v]) => v !== undefined && v !== '')
    );
}

export async function kontosMetStatus(
    status: KontoStatus,
    page = 0,
    size = 20
): Promise<PagedResult<Konto>> {
    return zoekKonto({ status }, page, size);
}

export const geschorsteKontos = (page?: number, size?: number) =>
    kontosMetStatus('GESCHORST', page, size);

export const pendingKontos = (page?: number, size?: number) =>
    kontosMetStatus('PENDING', page, size);


export async function activeerKonto(id: number): Promise<void> {

    const csrfToken = getCsrfToken();

    const response = await fetch(`/api/admin/kontos/${id}/activeer`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': csrfToken
        }
    });
    if (!response.ok) throw new Error(`activeerKonto failed: ${response.status}`);
}

export async function deactiveerKonto(id: number): Promise<void> {

    const csrfToken = getCsrfToken();

    const response = await fetch(`/api/admin/kontos/${id}/deactiveer`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': csrfToken
        }
    });
    if (!response.ok) throw new Error(`activeerKonto failed: ${response.status}`);
}